import { Action, Reducer } from 'redux';
import * as Actions from '../actions';
import {
  emptyStatementEntry,
  PractitionerAccountStatementState,
  PractitionerAccountStatementUnloadedState,
} from '../states/PractitionerAccountStatementState';
import {
  SectionState,
  StatementSection,
} from '../../models/Entities/PractitionerAccountStatement/PractitionerAccountStatement';

type KnownAction = Actions.PractitionerAccountStatement.PractitionerAccountStatementKnownAction;

const withSection = (
  state: PractitionerAccountStatementState,
  practitionerId: string,
  section: StatementSection,
  update: (current: SectionState<any>) => SectionState<any>
): PractitionerAccountStatementState => {
  const entry = state.byPractitioner[practitionerId] ?? emptyStatementEntry();
  return {
    ...state,
    byPractitioner: {
      ...state.byPractitioner,
      [practitionerId]: { ...entry, [section]: update(entry[section]) },
    },
  };
};

export const PractitionerAccountStatementReducer: Reducer<PractitionerAccountStatementState> = (
  state: PractitionerAccountStatementState | undefined,
  incomingAction: Action
): PractitionerAccountStatementState => {
  if (state === undefined) return PractitionerAccountStatementUnloadedState;

  const action = incomingAction as KnownAction;
  switch (action.type) {
    case 'PRACTITIONER_STATEMENT_SECTION_REQUEST_ACTION':
      // Se conserva el dato anterior mientras se vuelve a pedir: la tabla no parpadea al refrescar.
      return withSection(state, action.practitionerId, action.section, (current) => ({
        ...current,
        status: 'loading',
        error: undefined,
      }));
    case 'PRACTITIONER_STATEMENT_SECTION_RECEIVE_ACTION':
      return withSection(state, action.practitionerId, action.section, () => ({
        status: 'loaded',
        data: action.data,
        source: action.source,
        error: undefined,
      }));
    case 'PRACTITIONER_STATEMENT_SECTION_UNAVAILABLE_ACTION':
      return withSection(state, action.practitionerId, action.section, () => ({
        status: 'unavailable',
        data: undefined,
        error: undefined,
      }));
    case 'PRACTITIONER_STATEMENT_SECTION_FAIL_ACTION':
      return withSection(state, action.practitionerId, action.section, (current) => ({
        ...current,
        status: 'failed',
        error: action.error,
      }));
    default:
      return state;
  }
};
